/**
 * Essential product template interactions.
 * Runs only on .essential-product-page.
 * Location + retest + extra add-ons map to real Shopify variant IDs.
 */
(function () {
  function getRoot() {
    var cfg = document.querySelector("[data-essential-config]");
    if (cfg && cfg.closest) return cfg.closest(".essential-product-page");
    return document.querySelector(".essential-product-page[data-essential-root]") || document.querySelector(".essential-product-page");
  }

  function pageEl(selector) {
    var root = getRoot();
    return (root && root.querySelector(selector)) || document.querySelector(selector);
  }

  function initEssentialPage() {
  var root = getRoot();
  if (!root || root.getAttribute("data-essential-ready") === "1") return;
  root.setAttribute("data-essential-ready", "1");

  var main = document.getElementById("MainContent");
  if (main) {
    main.classList.remove("overflow-x-clip", "overflow-y-clip");
    main.classList.add("pwz-essential-main");
  }

  var cfgEl = root.querySelector("[data-essential-config]") || document.querySelector("[data-essential-config]");
  var productEl = root.querySelector("[data-essential-product]");
  var variantInput = root.querySelector("#pwz-essential-variant-id");
  var config = {
    available: true,
    variantId: variantInput ? variantInput.value : "",
    moneyFormat: "AED {{amount}}",
    hasOnlyDefaultVariant: true,
    soldOutLabel: "Sold Out",
    addLabelPrefix: "ADD TO CART — ",
  };
  if (cfgEl) {
    try {
      config = Object.assign(config, JSON.parse(cfgEl.textContent));
    } catch (e) {}
  }

  var productData = { options: [], variants: [] };
  if (productEl) {
    try {
      productData = Object.assign(productData, JSON.parse(productEl.textContent));
    } catch (e) {}
  }

  var addonCatalog = [];
  var addonsEl = root.querySelector("[data-essential-addons]");
  if (addonsEl) {
    try {
      var parsedAddons = JSON.parse(addonsEl.textContent);
      if (Array.isArray(parsedAddons)) addonCatalog = parsedAddons;
    } catch (e) {}
  }

  var matchedVariant = null;
  var isAdding = false;

  function formatMoney(cents) {
    cents = parseInt(cents, 10) || 0;
    if (window.Shopify && typeof Shopify.formatMoney === "function") {
      return Shopify.formatMoney(cents, config.moneyFormat);
    }
    var amount = (Math.abs(cents) / 100).toFixed(2);
    var parts = amount.split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    var withDecimals = parts.join(".");
    var noDecimals = String(Math.round(Math.abs(cents) / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return String(config.moneyFormat || "AED {{amount}}")
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDecimals)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withDecimals.replace(".", ","))
      .replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/g, withDecimals.replace(/,/g, "'"))
      .replace(/\{\{\s*amount\s*\}\}/g, withDecimals);
  }

  function normalize(value) {
    return String(value || "")
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, " ")
      .replace(/\s+/g, " ")
      .trim();
  }

  function selectedLocation() {
    return root.querySelector('input[name="location"]:checked');
  }

  function selectedLocationKey() {
    var loc = selectedLocation();
    return loc ? loc.value : "clinic";
  }

  function selectedLocationLabel() {
    var loc = selectedLocation();
    if (!loc) return "Precision Wellness, Dubai Science Park";
    var strong = loc.closest(".location-option") && loc.closest(".location-option").querySelector("strong");
    return strong ? strong.textContent.trim() : loc.value;
  }

  function retestSelected() {
    var retest = root.querySelector("#retestCheck");
    return !!(retest && retest.checked);
  }

  function addonInput(addon) {
    if (!addon || !addon.checkboxId) return null;
    return root.querySelector("#" + addon.checkboxId);
  }

  function addonSelected(addon) {
    var input = addonInput(addon);
    return !!(input && input.checked && !input.disabled);
  }

  function selectedAddonEntries() {
    return addonCatalog.filter(addonSelected);
  }

  function extraAddonsPricedInVariants() {
    return variantOptionIndexes().extraIndex !== -1;
  }

  function selectedExtraAddonKey() {
    var cortisol = false;
    var gut = false;
    addonCatalog.forEach(function (addon) {
      if (!addonSelected(addon)) return;
      if (addon.id === "cortisol") cortisol = true;
      if (addon.id === "gut-microbiome") gut = true;
    });
    if (!cortisol) {
      var cortisolInput = root.querySelector("#cortisolCheck");
      cortisol = !!(cortisolInput && cortisolInput.checked);
    }
    if (!gut) {
      var gutInput = root.querySelector("#gutMicrobiomeCheck");
      gut = !!(gutInput && gutInput.checked);
    }
    if (cortisol && gut) return "both";
    if (cortisol) return "cortisol";
    if (gut) return "gut";
    return "none";
  }

  function extraAddonKeyFromValue(value) {
    var n = normalize(value);
    if (!n) return "none";
    var hasCortisol = n.indexOf("cortisol") !== -1;
    var hasGut = n.indexOf("gut") !== -1 || n.indexOf("microbiome") !== -1;
    if (hasCortisol && hasGut) return "both";
    if (hasCortisol) return "cortisol";
    if (hasGut) return "gut";
    if (
      n === "none" ||
      n === "no" ||
      n === "no extras" ||
      n.indexOf("no add") !== -1 ||
      n.indexOf("without") !== -1 ||
      n.indexOf("none") !== -1
    ) {
      return "none";
    }
    return "none";
  }

  function extraAddonTotal() {
    if (extraAddonsPricedInVariants()) return 0;
    return selectedAddonEntries().reduce(function (sum, addon) {
      if (addon.pricing === "addon") return sum + (parseInt(addon.price, 10) || 0);
      return sum;
    }, 0);
  }

  function calculateTotalCents() {
    applyMatchedVariant();
    var base = matchedVariant
      ? Number(matchedVariant.price || 0)
      : Number((variantInput && variantInput.getAttribute("data-price")) || root.getAttribute("data-base-price") || 0);
    return base + extraAddonTotal();
  }

  function syncAddonProperties() {
    var selectedLabels = [];
    addonCatalog.forEach(function (addon) {
      var on = addonSelected(addon);
      if (on && addon.label) selectedLabels.push(addon.label);
      var prop = addon.propertyInputId ? root.querySelector("#" + addon.propertyInputId) : null;
      if (!prop) return;
      if (on) {
        prop.value = addon.propertyValue || "Yes";
        prop.disabled = false;
      } else {
        prop.value = "";
        prop.disabled = true;
      }
    });

    var selectedProp = root.querySelector("#pwz-essential-selected-options-prop");
    if (selectedProp) {
      if (selectedLabels.length) {
        selectedProp.value = selectedLabels.join(", ");
        selectedProp.disabled = false;
      } else {
        selectedProp.value = "";
        selectedProp.disabled = true;
      }
    }
    return selectedLabels;
  }

  function locationKeyFromValue(value) {
    var n = normalize(value);
    if (!n || n === "default title" || n === "title") return "";
    if (n.indexOf("other") !== -1) return "other";
    if (n.indexOf("science park") !== -1 || n.indexOf("precision wellness") !== -1) return "clinic";
    if (n.indexOf("dubai") !== -1) return "dubai";
    if (n.indexOf("clinic") !== -1) return "clinic";
    return "";
  }

  function isRetestOptionValue(value) {
    var n = normalize(value);
    if (!n) return false;
    if (n === "no" || n === "none" || n === "false" || n.indexOf("no retest") !== -1 || n.indexOf("without") !== -1) {
      return false;
    }
    return n.indexOf("retest") !== -1 || n.indexOf("6 month") !== -1 || n === "yes" || n === "true";
  }

  function optionNameLooksLikeLocation(name) {
    var n = normalize(name);
    return n.indexOf("location") !== -1 || n.indexOf("assessment") !== -1;
  }

  function optionNameLooksLikeRetest(name) {
    var n = normalize(name);
    return n.indexOf("retest") !== -1;
  }

  function optionNameLooksLikeExtra(name) {
    var n = normalize(name);
    return (
      n.indexOf("cortisol") !== -1 ||
      n.indexOf("gut") !== -1 ||
      n.indexOf("microbiome") !== -1 ||
      n.indexOf("extra") !== -1 ||
      n.indexOf("add on") !== -1 ||
      n.indexOf("addon") !== -1 ||
      n.indexOf("optional") !== -1
    );
  }

  function variantOptionIndexes() {
    var options = productData.options || [];
    var locationIndex = -1;
    var retestIndex = -1;
    var extraIndex = -1;
    options.forEach(function (name, index) {
      if (locationIndex === -1 && optionNameLooksLikeLocation(name)) locationIndex = index;
      if (retestIndex === -1 && optionNameLooksLikeRetest(name)) retestIndex = index;
      if (extraIndex === -1 && optionNameLooksLikeExtra(name)) extraIndex = index;
    });
    if (locationIndex === -1 && options.length) locationIndex = 0;
    if (retestIndex === -1 && options.length > 1) {
      retestIndex = locationIndex === 0 ? 1 : 0;
    }
    if (extraIndex === -1 && options.length > 2) {
      options.forEach(function (name, index) {
        if (extraIndex === -1 && index !== locationIndex && index !== retestIndex) extraIndex = index;
      });
    }
    return { locationIndex: locationIndex, retestIndex: retestIndex, extraIndex: extraIndex };
  }

  function variantOptionValue(variant, index) {
    if (!variant || index < 0) return "";
    if (variant.options && variant.options[index] != null) return variant.options[index];
    if (index === 0) return variant.option1 || "";
    if (index === 1) return variant.option2 || "";
    if (index === 2) return variant.option3 || "";
    return "";
  }

  function findMatchingVariant() {
    var variants = productData.variants || [];
    if (!variants.length) return null;

    var wantLocation = selectedLocationKey();
    var wantRetest = retestSelected();
    var wantExtra = selectedExtraAddonKey();
    var indexes = variantOptionIndexes();
    var matches = variants.filter(function (variant) {
      var locationValue = variantOptionValue(variant, indexes.locationIndex);
      var locationKey = locationKeyFromValue(locationValue || variant.title);
      if (!locationKey && variants.length === 1) return true;
      if (locationKey !== wantLocation) return false;

      if (indexes.retestIndex !== -1) {
        var retestValue = variantOptionValue(variant, indexes.retestIndex);
        if (isRetestOptionValue(retestValue) !== wantRetest) return false;
      } else if (wantRetest && !isRetestOptionValue(variant.title)) {
        return false;
      }

      if (indexes.extraIndex !== -1) {
        var extraValue = variantOptionValue(variant, indexes.extraIndex);
        return extraAddonKeyFromValue(extraValue || variant.title) === wantExtra;
      }
      return true;
    });

    if (!matches.length && indexes.extraIndex === -1) {
      matches = variants.filter(function (variant) {
        var locationValue = variantOptionValue(variant, indexes.locationIndex);
        var locationKey = locationKeyFromValue(locationValue || variant.title);
        return locationKey === wantLocation;
      });
    }

    if (matches.length) {
      return matches.find(function (variant) { return variant.available; }) || matches[0];
    }

    if (variants.length === 1) return variants[0];
    return variants[0] || null;
  }

  function applyMatchedVariant() {
    matchedVariant = findMatchingVariant();
    if (!matchedVariant) return;

    config.variantId = matchedVariant.id;
    config.available = matchedVariant.available !== false;
    config.price = Number(matchedVariant.price || 0);

    if (variantInput) {
      variantInput.value = matchedVariant.id;
      variantInput.setAttribute("data-price", String(config.price));
      variantInput.disabled = !config.available;
    }

    var locProp = root.querySelector("#pwz-essential-location");
    if (locProp) locProp.value = selectedLocationLabel();

    syncAddonProperties();

    try {
      var url = new URL(window.location.href);
      url.searchParams.set("variant", String(matchedVariant.id));
      window.history.replaceState({}, "", url.toString());
    } catch (e) {}
  }

  function updateTotal() {
    var total = calculateTotalCents();
    var loc = selectedLocation();
    var totalEl = root.querySelector("#totalPrice");
    var addMain = root.querySelector("#addMain");
    var stickyPrice = pageEl("#stickyPrice");
    var stickyLabel = pageEl("#stickyLabel");
    var money = formatMoney(total);
    var available = !!(matchedVariant && matchedVariant.available);

    if (totalEl) totalEl.textContent = money;
    if (addMain) {
      addMain.disabled = !available;
      addMain.textContent = available ? config.addLabelPrefix + money : config.soldOutLabel;
    }
    if (stickyPrice) stickyPrice.textContent = money;
    if (stickyLabel && loc) {
      var extras = selectedAddonEntries().map(function (addon) {
        return addon.shortLabel || addon.label;
      });
      stickyLabel.textContent = extras.length
        ? selectedLocationLabel() + " + " + extras.join(" + ")
        : selectedLocationLabel();
    }
    root.querySelectorAll(".location-option").forEach(function (option) {
      var input = option.querySelector("input");
      option.classList.toggle("active", !!(input && input.checked));
    });
    root.querySelectorAll(".addon").forEach(function (card) {
      var input = card.querySelector('input[type="checkbox"]');
      card.classList.toggle("is-selected", !!(input && input.checked));
    });

    var stickyAdd = pageEl("#stickyAdd");
    var buyNow = root.querySelector("#buyNow");
    [stickyAdd, buyNow].forEach(function (btn) {
      if (btn) btn.disabled = !available;
    });
  }

  function showToast(message) {
    var toast = pageEl("#pwz-essential-toast");
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add("show");
    window.clearTimeout(showToast._timer);
    showToast._timer = window.setTimeout(function () {
      toast.classList.remove("show");
    }, 1500);
  }

  function dispatchCartUpdate(cart) {
    document.dispatchEvent(
      new CustomEvent("cart:update", {
        bubbles: true,
        detail: {
          resource: cart,
          sourceId: "pwz-essential",
          data: {
            itemCount: cart && cart.item_count ? cart.item_count : 0,
            isIncremental: false,
            source: "pwz-essential",
          },
        },
      })
    );
    document.dispatchEvent(new CustomEvent("cart:updated", { bubbles: true, detail: { cart: cart } }));
    document.dispatchEvent(new CustomEvent("product-ajax:added", { bubbles: true, detail: { product: cart } }));
  }

  function collectItems() {
    var total = calculateTotalCents();
    var variantId = matchedVariant ? matchedVariant.id : variantInput ? variantInput.value : config.variantId;
    var properties = {
      Location: selectedLocationLabel(),
    };
    var extraItems = [];
    var selectedLabels = [];

    selectedAddonEntries().forEach(function (addon) {
      if (addon.propertyName) {
        properties[addon.propertyName] = addon.propertyValue || "Yes";
      }
      if (addon.label) selectedLabels.push(addon.label);
      if (!extraAddonsPricedInVariants() && addon.pricing === "addon" && addon.variantId) {
        extraItems.push({
          id: Number(addon.variantId),
          quantity: 1,
          properties: {
            "Added with": "Essential Assessment",
          },
        });
      }
    });

    if (selectedLabels.length) {
      properties["Selected options"] = selectedLabels.join(", ");
    }

    var items = [
      {
        id: Number(variantId),
        quantity: 1,
        properties: properties,
      },
    ];

    config.calculatedTotal = total;
    return items.concat(extraItems);
  }

  function addToCart(options) {
    options = options || {};
    if (isAdding) return Promise.resolve();
    applyMatchedVariant();
    if (!matchedVariant || !matchedVariant.available) {
      showToast(config.soldOutLabel);
      return Promise.resolve();
    }
    isAdding = true;
    var buttons = document.querySelectorAll("#addMain, #stickyAdd, #buyNow");
    buttons.forEach(function (btn) {
      btn.setAttribute("aria-busy", "true");
    });
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: collectItems() }),
    })
      .then(function (res) {
        return res.json().then(function (data) {
          return { ok: res.ok, data: data };
        });
      })
      .then(function (result) {
        if (!result.ok) {
          showToast(result.data.description || result.data.message || "Could not add to cart");
          return;
        }
        showToast(options.toast || "Essential added to cart");
        return fetch("/cart.js", { headers: { Accept: "application/json" } })
          .then(function (r) {
            return r.json();
          })
          .then(function (cart) {
            dispatchCartUpdate(cart);
            if (options.checkout) window.location.href = "/checkout";
          });
      })
      .catch(function () {
        showToast("Could not add to cart");
      })
      .finally(function () {
        isAdding = false;
        buttons.forEach(function (btn) {
          btn.removeAttribute("aria-busy");
        });
      });
  }

  root.querySelectorAll('input[name="location"]').forEach(function (input) {
    input.addEventListener("change", updateTotal);
  });
  root.querySelectorAll('.addon input[type="checkbox"]').forEach(function (input) {
    input.addEventListener("change", updateTotal);
  });
  var retest = root.querySelector("#retestCheck");

  root.querySelectorAll(".thumb").forEach(function (btn) {
    btn.addEventListener("click", function () {
      root.querySelectorAll(".thumb").forEach(function (item) {
        item.classList.remove("active");
      });
      btn.classList.add("active");
      root.querySelectorAll(".media-panel").forEach(function (panel) {
        panel.classList.remove("active");
      });
      var panel = root.querySelector("#panel-" + btn.getAttribute("data-panel"));
      if (panel) panel.classList.add("active");
    });
  });

  var form = root.querySelector("#pwz-essential-form");
  if (form) {
    form.addEventListener("submit", function (event) {
      event.preventDefault();
      addToCart({ toast: "Essential added to cart" });
    });
  }

  var stickyAdd = pageEl("#stickyAdd");
  if (stickyAdd && stickyAdd.getAttribute("data-essential-bound") !== "1") {
    stickyAdd.setAttribute("data-essential-bound", "1");
    stickyAdd.addEventListener("click", function () {
      addToCart({ toast: "Essential added to cart" });
    });
  }

  var buyNow = root.querySelector("#buyNow");
  if (buyNow) {
    buyNow.addEventListener("click", function () {
      addToCart({ toast: "Essential ready for checkout", checkout: true });
    });
  }

  var retestButton = pageEl("#retestButton");
  if (retestButton && retest && retestButton.getAttribute("data-essential-bound") !== "1") {
    retestButton.setAttribute("data-essential-bound", "1");
    retestButton.addEventListener("click", function () {
      retest.checked = true;
      updateTotal();
      showToast("6-month retest added");
    });
  }

  var sticky = pageEl("#pwz-essential-sticky");
  if (sticky && sticky.getAttribute("data-essential-scroll") !== "1") {
    sticky.setAttribute("data-essential-scroll", "1");
    var onScroll = function () {
      sticky.classList.toggle("show", window.scrollY > 850);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }

  var assessmentTrack = pageEl("#assessmentTrack");
  var assessmentPrev = pageEl("#assessmentPrev");
  var assessmentNext = pageEl("#assessmentNext");
  if (assessmentTrack && assessmentPrev && assessmentNext && assessmentTrack.getAttribute("data-essential-bound") !== "1") {
    assessmentTrack.setAttribute("data-essential-bound", "1");
    var move = function () {
      return Math.max(assessmentTrack.clientWidth * 0.72, 320);
    };
    assessmentPrev.addEventListener("click", function () {
      assessmentTrack.scrollBy({ left: -move(), behavior: "smooth" });
    });
    assessmentNext.addEventListener("click", function () {
      assessmentTrack.scrollBy({ left: move(), behavior: "smooth" });
    });
  }

  updateTotal();
  }

  initEssentialPage();

  document.addEventListener("shopify:section:load", function (event) {
    var target = event.target;
    if (!target) return;
    var root = getRoot();
    if (root) root.removeAttribute("data-essential-ready");
    var extras = document.querySelectorAll("#retestButton, #assessmentTrack, #pwz-essential-sticky, #stickyAdd");
    extras.forEach(function (el) {
      if (el) {
        el.removeAttribute("data-essential-bound");
        el.removeAttribute("data-essential-scroll");
      }
    });
    initEssentialPage();
  });
})();
